import {Button, Group, Title, Tooltip} from '@mantine/core'
import {IconTruckDelivery} from '@tabler/icons-react'
import {Link} from '@tanstack/react-router'

import {NEW_WIZARD_SEARCH} from 'src/jobs/create-job-storage'

import {ProjectsPage} from './projects-page'

export function ProjectsHubPage() {
    return (
        <>
            <Group justify="space-between" mb="md">
                <Title order={1}>Orders</Title>
                <Group gap="sm">
                    <Button component={Link} to="/active-rentals" size="sm" variant="outline">
                        Active rentals
                    </Button>
                    <Button component={Link} to="/jobs" size="sm" variant="outline">
                        View all jobs
                    </Button>
                    <Tooltip
                        label="A job is a single piece of work, like moving equipment to a site."
                        withArrow
                    >
                        <Button
                            renderRoot={(props) => (
                                <Link {...props} to="/jobs/create" search={NEW_WIZARD_SEARCH} />
                            )}
                            leftSection={<IconTruckDelivery size={18} stroke={1.5} />}
                        >
                            Create job
                        </Button>
                    </Tooltip>
                </Group>
            </Group>
            <ProjectsPage embedded showMineOrAll syncUrlSearch />
        </>
    )
}
